export const FIND_BY_USER_ID = 'STATISTICS:FIND_BY_USER_ID';
export const FIND_BY_USER_ID_SUCCESS = 'STATISTICS:FIND_BY_USER_ID_SUCCESS';
export const FIND_BY_USER_ID_ERROR = 'STATISTICS:FIND_BY_USER_ID_ERROR';
export const SET_STATISTICS = 'STATISTICS:SET_STATISTICS';